<template>
  <div class="formTel formField">
    <div class="formTel__inner">
      <div v-if="label" :class="['formTel__label', disabled ? 'formTel__label--disabled' : '']">
        {{ label }}
      </div>
      <vue-tel-input
        :value="value ? value : ''"
        :only-countries="options"
        input-classes="formTel__input"
        :required="required"
        :disabled="disabled"
        :name="name"
        mode="international"
        @input="onInput"
        default-country="PL"
        placeholder="Numer telefonu"
        :preferred-countries="['PL']"
        :input-options="inputOptions"
      >
        <template #arrow-icon>
          <span class="vti__selection-icon icon-chevron-down" />
        </template>
      </vue-tel-input>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  name: 'FormTel',
  components: {
    VueTelInput,
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      telObj: null,
      inputOptions: {
        placeholder: 'Wpisz numer telefonu',
      },
      options: [
        'PL',
        'AT',
        'BE',
        'BG',
        'CY',
        'CZ',
        'DE',
        'DK',
        'EE',
        'ES',
        'FI',
        'FR',
        'GR',
        'HR',
        'HU',
        'IE',
        'IT',
        'LT',
        'LU',
        'LV',
        'MT',
        'NL',
        'PT',
        'RO',
        'SE',
        'SI',
        'SK',
      ],
    };
  },
  methods: {
    onInput(value, obj) {
      this.telObj = obj;
      this.$emit('input', value, obj);
    },
  },
};
</script>

<style lang="scss">
.formTel {
  $root: &;

  &__inner {
    position: relative;
  }

  &__label {
    position: absolute;
    left: 8rem;
    top: -0.9rem;
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 600;
    padding: 0 1rem;
    z-index: 10;
    color: $cMainDark;
    background-color: $cWhite;
    pointer-events: none;

    &--disabled {
      background-color: transparent;
    }
  }

  &.is-invalid {
    #{$root}__input {
      border: 2px solid $cBadgeProm;
    }
  }
}
.vue-tel-input {
  border: 0 !important;

  &:focus-within {
    box-shadow: none !important;
  }

  .vti__dropdown {
    border: 1px solid $cAddLight;
    height: 4.8rem;
    border-radius: 4px;

    &-list {
      z-index: 11;
    }

    &-list.below {
      top: 46px;
    }

    &-item {
      padding: 0.6rem 1.5rem;
    }
  }

  .vti__input {
    border: 1px solid $cAddLight;
    height: 4.8rem;
    border-radius: 4px;
    margin-left: 1rem;
    padding-left: 2rem;
    padding-right: 2rem;
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: $cMainLight;

    &::placeholder {
      color: $cAddDark02;
    }

    &:disabled {
      background-color: $cBg;
      cursor: default;
    }
  }

  .vti__selection {
    &-icon {
      font-size: 0.6rem;
      color: $cMainLight;
      padding-left: 4px;
    }
  }

  .vue-tel-input:focus-within {
    box-shadow: none !important;
  }

  &.disabled {
    .vti__dropdown {
      cursor: default;
      background-color: $cBg;
    }
  }
}
</style>
